import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import { IWidgetInfo } from '../../interfaces/widget-settings.interfaces';

export interface IWidgetSettingsState {
  widgetSettings: IWidgetInfo | null;
  loading: boolean;
  error: string | null;
}

const initialState: IWidgetSettingsState = {
  widgetSettings: null,
  loading: false,
  error: null,
};

export const widgetSettingsSlice = createSlice({
  initialState,
  name: 'widget-settings',
  reducers: {
    updateWidgetSettingsRequest: (state): void => {
      state.loading = true;
      state.error = null;
    },
    updateWidgetThemeRequest: (state): void => {
      state.loading = true;
      state.error = null;
    },
    loadWidgetSettingsRequest: (state): void => {
      state.loading = true;
      state.error = null;
    },
    loadWidgetSettingsRequestError: (state, { payload: error }: PayloadAction<string>): void => {
      state.loading = false;
      state.error = error;
    },
    loadWidgetSettingsRequestSuccess: (state, { payload: widgetSettings }: PayloadAction<IWidgetInfo>): void => {
      state.widgetSettings = widgetSettings;
      state.loading = false;
      state.error = null;
    }
  }
});

export const WidgetSettingsActions = widgetSettingsSlice.actions;
